var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('p',[_vm._v("Loading...")]):_vm._e(),(!_vm.isLoading)?_c('section',{staticClass:"input-unit",class:{
      'hide-border': _vm.hideBorder,
      'unset-max-width': _vm.unsetMaxWidth,
      'bold': _vm.bold,
      'autocomplete-upah': !_vm.upahName && !_vm.readOnly
    }},[_c('b-field',[_c('b-autocomplete',{attrs:{"field":"name","placeholder":"Pilih Upah Kerja","clearable":!_vm.disabled,"open-on-focus":"","data":_vm.filteredData,"disabled":_vm.disabled},on:{"focus":_vm.resetSearch,"select":(option) => _vm.handleSelectUnit(option),"input":(e) => _vm.handleChangeInput(e)},model:{value:(_vm.upahName),callback:function ($$v) {_vm.upahName=$$v},expression:"upahName"}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }